module.exports = __webpack_public_path__ + "static/img/pro2-2.a2717e5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/pro2-2.png
// module id = 3aS+
// module chunks = 0